import axios from "axios";
import {
  AUTH_TOKEN_KEY,
  AUTH_SESSION_HINT_KEY,
  CSRF_TOKEN_KEY,
} from "../constants/storageKeys";

function readStorageValue(key) {
  return localStorage.getItem(key) || sessionStorage.getItem(key) || "";
}

function writeStorageValue(key, value, remember = true) {
  if (!value) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
    return;
  }

  if (remember) {
    localStorage.setItem(key, value);
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, value);
  localStorage.removeItem(key);
}

export function getStoredToken() {
  return (
    readStorageValue(AUTH_SESSION_HINT_KEY) ||
    readStorageValue(AUTH_TOKEN_KEY) ||
    ""
  );
}

export function getTokenStorageMode() {
  if (localStorage.getItem(AUTH_SESSION_HINT_KEY) || localStorage.getItem(AUTH_TOKEN_KEY)) {
    return "local";
  }
  if (sessionStorage.getItem(AUTH_SESSION_HINT_KEY) || sessionStorage.getItem(AUTH_TOKEN_KEY)) {
    return "session";
  }
  return "none";
}

export function setStoredToken(token, options = {}) {
  const remember = options?.remember !== false;
  writeStorageValue(AUTH_SESSION_HINT_KEY, token ? "1" : "", remember);
  localStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);

  if (!token) {
    writeStorageValue(CSRF_TOKEN_KEY, "", remember);
  }
}

export function getStoredCsrfToken() {
  return readStorageValue(CSRF_TOKEN_KEY);
}

export function setStoredCsrfToken(token, options = {}) {
  const remember =
    options?.remember != null ? options.remember : getTokenStorageMode() !== "session";
  writeStorageValue(CSRF_TOKEN_KEY, token || "", remember);
}

export function clearStoredAuthState() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_SESSION_HINT_KEY);
  sessionStorage.removeItem(AUTH_SESSION_HINT_KEY);
  localStorage.removeItem(CSRF_TOKEN_KEY);
  sessionStorage.removeItem(CSRF_TOKEN_KEY);
}

function isUnsafeMethod(method) {
  const normalized = String(method || "get").toUpperCase();
  return !["GET", "HEAD", "OPTIONS"].includes(normalized);
}

export const apiClient = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    `${String(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/api`,
  timeout: 20000,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  if (isUnsafeMethod(config.method)) {
    const csrfToken = getStoredCsrfToken();
    if (csrfToken) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = csrfToken;
    }
  }
  return config;
});

export function getApiErrorMessage(error, fallback = "İşlem sırasında bir hata oluştu.") {
  return error?.response?.data?.error || error?.message || fallback;
}

export function isConflictError(error) {
  return error?.response?.status === 409;
}

export function getConflictCurrent(error) {
  return error?.response?.data?.details?.current || null;
}
